// extracted by mini-css-extract-plugin
module.exports = {"whatWeDo":"what-we-do_whatWeDo__2HJb4","grid":"what-we-do_grid__vWLIv","item":"what-we-do_item__1558c","title":"what-we-do_title__Yhz9z","desc":"what-we-do_desc__1i5EP"};